<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="productDetailRefundInfo.orders"
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="cartId" label="订单号" align="center" />
        <el-table-column prop="prodName" label="商品名称" align="center" />
        <el-table-column prop="personName" label="用户名称" align="center" />
        <el-table-column prop="returnPayPrice" label="退款金额" align="center" />
        <el-table-column prop="stateName" label="订单状态" align="center" />
        <el-table-column prop="returnReason" label="退款原因" align="center" />
        <el-table-column prop="createTime" label="申请时间" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryRefundOrders } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailRefund',
  data() {
    return {
      productDetailRefundInfo: {
        orders: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailRefundInfo.productId = params.productId
      this.loadProductDetailRefundData()
    },
    async loadProductDetailRefundData() {
      const res = await queryRefundOrders({
          productId: this.productDetailRefundInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })

      this.productDetailRefundInfo.orders = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailRefundData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>